"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var QueriesStore_1 = require("stores/QueriesStore");
var PODQueryStage4_1 = __importDefault(require("./PODQueryStage4"));
var PriceQueryStage4_1 = __importDefault(require("./PriceQueryStage4"));
var FleetQueryStage4_1 = __importDefault(require("./FleetQueryStage4"));
var QueryDetailsStage4 = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: "query-stage query-stage-4" },
        data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            react_1.default.createElement(PriceQueryStage4_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement(FleetQueryStage4_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement(PODQueryStage4_1.default, { data: data })));
};
exports.default = QueryDetailsStage4;
